<template>
  <div class="home">
      <div class="bCon">
          <banner-Component :banner="data.banner" :banner2="data.banner2" ></banner-Component>

          <div class="btn" style="cursor: pointer">
              <button class="cta-btn">
                  <svg  viewBox="0 0 89 89" class="border">
                      <path  d="M87.5,44.5a43,43,0,1,1-43-43A43,43,0,0,1,87.5,44.5Z"></path>
                  </svg>
                  <svg  viewBox="0 0 89 89" class="outline">
                      <path  d="M44.5,1.5a43,43,0,1,0,.77,0Z"></path>
                  </svg>
              </button>
              <img src="../assets/aem/play.png" alt="">
          </div>

      </div>
  <div class="main" v-if="$i18n.locale === 'zh'">
      <div class="title wow fadeInUp">
           <p class="t1"><span>LATEST</span>NEWS</p>
          <p class="t2">最新消息</p>
      </div>
      <div class="allImgs wow fadeInUp">
          <swiper :options="swiperOptiona" ref="mySwipers" class="swiper">
              <swiper-slide class="item" v-for="(item,index) in data.news" :key="index">
                  <div class="info" @click="gotoInfo(item.id)">
                       <div class="pic">
                            <img :src="`${imageUrl}${item.cover}`"  alt="">
                           <div class="nr">
                               <p class="p1">{{item.title}}</p>
                               <p class="p2">
                                   <i class="iconfont icon-shijian"></i>
                                   <span>{{item.publishTime}}</span>
                               </p>
                               <p class="p3">{{item.description}}</p>
                             <div class="btn">
                              查看更多
                             </div>
                           </div>
                           <div class="line">

                           </div>
                           <div class="pbg">

                           </div>

                       </div>

                  </div>

              </swiper-slide>
          </swiper>
      </div>
      <vue-particles   class="lz wow fadeIn"
                       color="#BFD8DE"
                       :particleOpacity="0.1"
                       :particlesNumber="100"
                       shapeType="star"
                       :particleSize="1"
                       linesColor="#02509B"
                       :linesWidth="1"
                       :lineLinked="true"
                       :lineOpacity="0.2"
                       :linesDistance="150"
                       :moveSpeed="3"
                       :hoverEffect="true"
                       hoverMode="grab"
                       :clickEffect="false"
      ></vue-particles>
      <div class="swiper-pagination"></div>
  </div>

      <foot-Component class="foot wow fadeIn"></foot-Component>
  </div>
</template>

<script>
  import bannerComponent from '../components/banner'
  import Scrollbar from 'smooth-scrollbar'
  import footComponent from '../components/foot'
//   import {getHomeInfo} from "../util/lang";
  import HomeService from "@/services/HomeService"
  import global from "@/util/global"
  import {swiper, swiperSlide} from "vue-awesome-swiper";
  import "swiper/dist/css/swiper.css";
  

  export default {
  name: 'home',
    data(){
      return{
        imageUrl: global.imageUrl,
          swiperOptiona: {
              loop: true,
              init: true,
              slidesPerView:4,
              speed:1000,
              autoplay: false,
              spaceBetween:50,
              breakpoints:{
                  1199:{
                      slidesPerView :1,
                  }
              },
              pagination: {
                  el: '.main .swiper-pagination',
                  clickable: true,
                  renderBullet: function (index, className) {
                      return '<div class="'+className+'">'+'<svg id="ec8ewxfout1i1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 38 38" shape-rendering="geometricPrecision" text-rendering="geometricPrecision">'+'<circle id="ec8ewxfout1i2" r="17.520910" transform="matrix(0 -1 1 0 19.00000000000001 18.99999999999999)" fill="none" stroke="#00748D" stroke-width="2" stroke-miterlimit="10" stroke-dashoffset="110.090000" stroke-dasharray="110.090000"/>'+'</svg>'+'</div>';
                  },
              },
          },
          scrollbar:'',
          data:{
              banner:[],
              banner2:[],
              news:[]
          }
      }
    },
    mounted() {
        Scrollbar.initAll(document.getElementById("scroller-wrapper"));
        let scrollbar=Scrollbar.get(document.getElementById('scroller-wrapper'))
        scrollbar.scrollTo(0,0)
        this.scrollbar = Scrollbar.init(document.getElementById('scroller-wrapper'));
        window.pageYOffset=this.scrollbar.scrollTop
        this.scrollbar.addListener((status) => {

        });
        this.$nextTick(() => {
           this.getHome(1);
           this.getHome(2);
           this.getnews()
        })
    },
    components:{bannerComponent,footComponent,swiper, swiperSlide},
    methods:{
        async getHome(type){
            const params = {
                type,
                language: this.$i18n.locale === "zh" ? 1 : 2
            }
            const { data } = await HomeService.broadcastList(params);
            if (data.length && type === 1) {
                this.data.banner = data.map(item => {
                    return { picurl: item.picurl, title:item.title, type: item.type, description: item.description }
                })
            }
            if (data.length && type === 2) {
                this.data.banner2 = data.map(ele => {
                    return {
                        picurl: ele.picurl,
                        title:ele.title, 
                        type: ele.type, 
                        description: ele.description
                    }
                })
            }
        },
        async getnews() {
            const params = {
                isNews: 1,
                language: this.$i18n.locale === "zh" ? 1 : 2
            }
            const {data} = await HomeService.articleList(params)
            this.data.news = data
        },
        gotoInfo(id){
            const link=`/newsInfo.html?id=${id}&type=0`
            window.open(link,'_blank')
        },
        gotoAbout(){
            const link='/about.html'
            window.open(link,'_self')
        }
    }
}
</script>

<style lang="scss" scoped>
    .home {
        width: 100%;
        animation: run5 1s linear forwards;
        perspective: 2000px;
        @keyframes run5 {
            from {
                opacity: 0;
            }
            to {
                opacity: 1;
            }
        }
        .bCon {
            position: relative;
            height: 100vh;
            overflow: hidden;
            width: 100%;
            .btn{
                position: absolute;
               bottom:30%;
                left: 10%;
                width: 60px;
                height: 60px;
                /*&::before{*/
                /*    content:'';*/
                /*    display: inline-block;*/
                /*    width:94%;*/
                /*    height:92%;*/
                /*    position: absolute;*/
                /*    left:1%;*/
                /*    top:2%;*/
                /*    border: 1px solid rgba(255,255,255,.5);*/
                /*    z-index: 100;*/
                /*    border-radius: 50%;*/
                /*}*/
                .cta-btn{
                    position: absolute;
                    bottom:0;
                    left: 0;
                    width: 100%;
                    height:100%;
                    border-radius: 50%;
                    background-color: transparent;
                    cursor: pointer;
                    border: 1px solid rgba(255,255,255,.5);
                    svg{
                        position: absolute;
                        top: 0;
                        left: 0;
                        overflow: hidden;
                    }
                    .border{
                        stroke-dasharray: 0;
                        stroke-dashoffset: 0;
                        stroke-width: 2px;
                        path{
                            fill: none;
                            stroke: hsla(0,0%,100%,.3);
                            stroke-miterlimit: 10;
                        }
                    }
                    .outline{
                        z-index: 1;
                        path{
                            fill: none;
                            stroke-miterlimit: 10;
                            stroke: #fff;
                            stroke-dasharray: 300;
                            /*stroke-dashoffset: 300;*/
                            stroke-width: 2px;
                            animation: run 5s infinite linear;
                        }
                    }
                    @keyframes run {
                        0%{
                            stroke-dashoffset: -300;
                        }
                        50%{
                            stroke-dashoffset: -150;
                        }
                        100%{
                            stroke-dashoffset: 0;
                        }
                        50%{
                            stroke-dashoffset: 150;
                        }
                        0%{
                            stroke-dashoffset: 300;
                        }
                    }
                }
                img{
                    position: absolute;
                    left:50%;
                    top:50%;
                    z-index: 10;
                    height:15px;
                    object-fit: contain;
                    width:15px;
                    transform: translate(-50%,-50%);
                    cursor: pointer;
                }
            }
        }
        .main {
            width: 100%;
            margin-top: 80px;
            position: relative;
            padding-bottom: 200px;
            /*div{*/
            /*    opacity: 0;*/
            /*    transition: all 0.8s;*/
            /*    transform: translateY(30px);*/
            /*}*/
            /*.show{*/
            /*    opacity: 1;*/
            /*    transform: translateY(0);*/
            /*}*/
            .lz{
                position: absolute;
                left:0;
                bottom:0;
                width:100%;
                height:500px;
            }
            .title{
                margin: 60px auto;
                animation-duration: 1s;
             .t1{
                 display: flex;
                 flex-direction: row;
                 justify-content: center;
                 font-size: 40px;
                 font-family: "helveticaneueltstd-blkcn";
                 text-transform: uppercase;
                 color:rgba(102, 102, 102, 1);
                 span{
                     color:rgba(0, 116, 141, 1);
                     display: inline-block;
                     margin-right: 10px;
                 }
             }
                .t2{
                    color:#333333;
                    font-size: 22px;
                    font-family: 'SOURCEHANSANSCN-REGULAR';
                    text-align: center;
                    margin-top: 5px;
                }
            }
            .allImgs{
                width:80%;
                margin: 60px auto;
                animation-duration: 1s;
                .swiper{
                    width:100%;
                    .item{
                        .info{
                            position: relative;
                            cursor: pointer;
                            .pic{
                                width:100%;
                                position: relative;
                                overflow: hidden;
                                .pbg{
                                    width: 100%;
                                    height:100%;
                                    position: absolute;
                                    left:0;
                                    top:0;
                                    opacity: 0;
                                    transition: all 500ms;
                                    background: linear-gradient(0deg, rgba(2, 24, 27, 0.9) 0%, rgba(2, 24, 27, 0.5) 100%);
                                }
                                img{
                                    width:100%;
                                    height: 246px;
                                    display: block;
                                    object-fit: contain;
                                    transition: all 0.8s;
                                }
                                .nr{
                                    width:80%;
                                    position: absolute;
                                    left:10%;
                                    height:100%;
                                    top:0;
                                    transform: translateY(78%);
                                    z-index: 10;
                                    transition: all 0.8s;
                                    .p1{
                                        text-align: center;
                                        font-size: 15px;
                                        font-family: 'SOURCEHANSANSCN-MEDIUM';
                                        color:white;
                                    }
                                    .p2{
                                        display: flex;
                                        flex-direction: row;
                                        justify-content: center;
                                        color:white;
                                        font-family: 'SOURCEHANSANSCN-LIGHT';
                                        align-items: center;
                                        margin: 15px auto;
                                        opacity: 0;
                                        transition: all 0.8s;
                                        transform: translateY(30px);
                                        transition-delay: 100ms;
                                        i{
                                            font-size: 18px;
                                        }
                                        span{
                                            display: inline-block;
                                            margin-left: 8px;
                                        }
                                    }
                                    .p3{
                                        color:white;
                                        font-size: 14px;
                                        line-height: 25px;
                                        font-family: 'SOURCEHANSANSCN-LIGHT';
                                        text-align: center;
                                        opacity: 0;
                                        transition: all 0.8s;
                                        transform: translateY(30px);
                                        transition-delay:200ms;
                                    }
                                    .btn{
                                        width: 140px;
                                        height: 40px;
                                        background: #00748D;
                                       margin: 30px auto;
                                        text-align: center;
                                        line-height: 45px;
                                        color:white;
                                        font-size: 14px;
                                        font-family: 'SOURCEHANSANSCN-LIGHT';
                                        position: relative;
                                        opacity: 0;
                                        transition: all 0.8s;
                                        transform: translateY(30px);
                                        transition-delay:300ms;
                                        &::after{
                                            content:'';
                                            display: inline-block;
                                            width:100%;
                                            height:95%;
                                            top:0px;
                                            left:0px;
                                            position: absolute;
                                            border: 1px solid #FFFFFF;
                                        }
                                    }
                                }
                                .line{
                                    position: absolute;
                                    left:50%;
                                    width:1px;
                                    height:15px;
                                    background-color: rgba(255,255,255,.5);
                                    bottom:0;
                                    z-index: 10;
                                    animation: long 2s infinite ease;
                                    transition: all 500ms;
                                }
                                @keyframes long {
                                   0%{
                                       height:15px;
                                   }
                                    50%{
                                        height:45px;
                                    }
                                    100%{
                                        height:15px;
                                    }
                                }
                                &:hover{
                                    img{
                                        transform: scale(1.02);
                                    }
                                    .pbg{
                                        opacity: 1;
                                    }
                                    .nr{
                                        transform: translateY(15%);
                                        .p2,.p3,.btn{
                                            opacity: 1;
                                            transform: translateY(0);
                                        }
                                    }
                                }
                            }
                        }
                    }
                    .item:nth-of-type(2n){
                        .info{
                            padding-top: 60px;
                        }
                    }
                }
            }
        }
        .foot {
            animation-duration: 2s;
        }
        @keyframes transition1 {
            0% {
                transform: translate(-100px, -100px);
                opacity: 0;
            }
            100% {
                transform: translate(0, 0);
                opacity: 1;
            }
        }
        @keyframes transition2 {
            0% {
                transform: translate(100px, -100px);
            }
            100% {
                transform: translate(0, 0);
            }
        }
        @keyframes polygon {
            0% {
                clip-path: polygon(100% 0, 99% 50%, 50% 99%, 100% 50%);
                opacity: 0;
            }
            100% {
                clip-path: polygon(0% 0%, 0% 100%, 100% 100%, 100% 0%);
                opacity: 1;
            }
        }
        @media screen and (max-width: 1000px) {
           .main{
               margin-top: 30px;
               padding-bottom: 100px;
               .title{
                   margin: 30px auto;
                   .t1{
                       font-size: 20px;
                   }
                   .t2{
                       font-size: 18px;
                   }
               }
               .allImgs{
                   margin: 30px auto;
                   .swiper{
                       .item{
                           .info{
                               padding: 0 !important;
                               .pic{
                                   .nr{
                                       .p1{
                                           font-size: 15px;
                                       }
                                   }
                               }
                           }
                       }
                   }
               }
           }
        }
    }
</style>
<style scoped>
   .swiper-pagination {
        bottom: 10%;
        transform: translateY(50%);
        display: flex;
        flex-direction: row;
        justify-content: center;
        z-index: 1000;
        width:100%;
        max-width: 100vw;
        overflow-x: hidden;
    }

    .swiper-pagination >>> .swiper-pagination-bullet{
        width: 20px;
        height:20px;
        border-radius: 50%;
        margin: 0 15px;
        cursor: pointer;
        position: relative;
        opacity: 1;
        background-color: transparent;
    }
     .swiper-pagination >>> .swiper-pagination-bullet::before{
        content:'';
        display: inline-block;
        width: 4px;
        height: 4px;
        background:#999999;
        border-radius: 50%;
        position: absolute;
        left:8px;
        top:8px;
        transition: all 500ms;
    }
     .swiper-pagination >>> .swiper-pagination-bullet-active svg circle {
        animation: ec8ewxfout1i2_s_da 2s linear 1 normal forwards;
    }
     .swiper-pagination >>> .swiper-pagination-bullet-active::before{
        background-color: #00748D;
    }
    .swiper-pagination >>> .swiper-pagination-bullet:focus {
        outline: none;
    }
    @keyframes ec8ewxfout1i2_s_da { 0% {stroke-dasharray: 110.090000;animation-timing-function: cubic-bezier(1,0.040000,0.965000,0.145000)} 100% {stroke-dasharray: 360} }
    @media screen and (max-width: 1000px) {
        .swiper-pagination >>> .swiper-pagination-bullet{
            margin: 0 10px;
        }
    }
</style>
